import { Reducer } from 'redux';
import { UserState, UserTypes, User } from './types';

const INITIAL_STATE: UserState = {
  user: {} as User,
};

const reducer: Reducer<UserState> = (state = INITIAL_STATE, action) => {
  const updatedUserState = state;

  switch (action.type) {
    case UserTypes.UPDATE_USER:
      updatedUserState.user = action.payload;

      return { ...state, ...updatedUserState };

    case UserTypes.REMOVE_USER:
      // resetar estado do usario
      INITIAL_STATE.user = {} as User;

      return { ...state, ...INITIAL_STATE };

    default:
      return state;
  }
};

export default reducer;
